const sectionCheck = [
  {
    section: "profile",
    score: 20,
    minimum_sections: false,
    checkFields: ["name", "jobTitle", "email", "phone"],
  },
  {
    section: "summary",
    score: 20,
    minimum_sections: false,
    checkFields: ["description"],
  },
  {
    section: "experience",
    score: 30,
    minimum_sections: false,
    checkFields: ["position", "company", "location", "date"],
  },
  {
    section: "skills",
    score: 15,
    minimum_sections: 3,
    checkFields: ["name", "level"],
  },
  {
    section: "education",
    score: 15,
    minimum_sections: false,
    checkFields: ["degree", "school", "location", "date"],
  },
  // {
  //   section: "references",
  //   score: 3,
  //   minimum_sections: false,
  //   checkFields: ["description"],
  // },
  // {
  //   section: "courses",
  //   score: 3,
  //   minimum_sections: false,
  //   checkFields: ["description"],
  // },
  // {
  //   section: "interests",
  //   score: 4,
  //   minimum_sections: false,
  //   checkFields: ["name"],
  // },
  // {
  //   section: "achievements",
  //   score: 4,
  //   minimum_sections: false,
  //   checkFields: ["name", "description"],
  // },
  // {
  //   section: "languages",
  //   score: 4,
  //   minimum_sections: false,
  //   checkFields: ["name", "level"],
  // },
];

export const CalculatecompletedPercentage = (json) => {
  if (json && json.profile) {
    let calculatedData = {};
    let completedPercentage = 0;
    let missingSections = [];
    let missingFields = [];
    let sectionPosition = json.sectionPosition;
    sectionCheck &&
      sectionCheck.map((res) => {
        const lsbar = sectionPosition && sectionPosition.lsbar;
        const rsbar = sectionPosition && sectionPosition.rsbar;
        const lsbarIndex = lsbar && lsbar.findIndex((x) => x == res.section);
        const rsbarIndex = rsbar && rsbar.findIndex((x) => x == res.section);
        if (lsbarIndex != -1 || rsbarIndex != -1) {
          if (res?.checkFields) {
            res?.checkFields?.map((fields, index) => {
              if (
                fields != "description" &&
                fields != "date" &&
                json &&
                json[res.section] &&
                json[res.section].data &&
                json[res.section].data[0] &&
                json[res.section].data[0][fields] &&
                json[res.section].data[0][fields] != ""
              ) {
              } else if (fields == "date") {
                if (
                  json &&
                  json[res.section] &&
                  json[res.section].data &&
                  json[res.section].data[0] &&
                  json[res.section].data[0]["dateRange"] &&
                  json[res.section].data[0]["dateRange"]
                ) {
                  // for from date
                  const fromMonth =
                    json &&
                    json[res.section] &&
                    json[res.section].data &&
                    json[res.section].data[0] &&
                    json[res.section].data[0]["dateRange"] &&
                    json[res.section].data[0]["dateRange"]["fromMonth"];
                  const fromYear =
                    json &&
                    json[res.section] &&
                    json[res.section].data &&
                    json[res.section].data[0] &&
                    json[res.section].data[0]["dateRange"] &&
                    json[res.section].data[0]["dateRange"]["fromYear"];

                  if (
                    (fromMonth != "" && fromMonth != null) ||
                    (fromYear != "" && fromYear != null)
                  ) {
                  } else {
                    const checkSectionAvailable = missingFields.findIndex(
                      (x) => x.section == [res.section]
                    );

                    if (checkSectionAvailable == -1) {
                      let data = {
                        section: res.section,
                        score: res.score,
                        fields: ["from"],
                      };
                      missingFields.push(data);
                    } else {
                      missingFields[checkSectionAvailable] &&
                        missingFields[checkSectionAvailable].fields &&
                        missingFields[checkSectionAvailable].fields.push(
                          "from"
                        );
                    }
                  }

                  // for to date
                  const toMonth =
                    json &&
                    json[res.section] &&
                    json[res.section].data &&
                    json[res.section].data[0] &&
                    json[res.section].data[0]["dateRange"] &&
                    json[res.section].data[0]["dateRange"]["toMonth"];
                  const toYear =
                    json &&
                    json[res.section] &&
                    json[res.section].data &&
                    json[res.section].data[0] &&
                    json[res.section].data[0]["dateRange"] &&
                    json[res.section].data[0]["dateRange"]["toYear"];

                  const isOnGoing =
                    json &&
                    json[res.section] &&
                    json[res.section].data &&
                    json[res.section].data[0] &&
                    json[res.section].data[0]["dateRange"] &&
                    json[res.section].data[0]["dateRange"]["isOnGoing"];

                  if (
                    (toMonth != "" && toMonth != null) ||
                    (toYear != "" && toYear != null) ||
                    isOnGoing
                  ) {
                  } else {
                    const checkSectionAvailable = missingFields.findIndex(
                      (x) => x.section == [res.section]
                    );

                    if (checkSectionAvailable == -1) {
                      let data = {
                        section: res.section,
                        score: res.score,
                        fields: ["to"],
                      };
                      missingFields.push(data);
                    } else {
                      missingFields[checkSectionAvailable] &&
                        missingFields[checkSectionAvailable].fields &&
                        missingFields[checkSectionAvailable].fields.push("to");
                    }
                  }
                }
              } else if (fields == "description") {
                if (
                  json &&
                  json[res.section] &&
                  json[res.section].data &&
                  json[res.section].data[0] &&
                  json[res.section].data[0][fields] &&
                  json[res.section].data[0][fields] == "<p><br></p>"
                ) {
                  const checkSectionAvailable = missingFields.findIndex(
                    (x) => x.section == [res.section]
                  );

                  if (checkSectionAvailable == -1) {
                    let data = {
                      section: res.section,
                      score: res.score,
                      fields: [fields],
                    };
                    missingFields.push(data);
                  } else {
                    missingFields[checkSectionAvailable] &&
                      missingFields[checkSectionAvailable].fields &&
                      missingFields[checkSectionAvailable].fields.push(fields);
                  }
                } else if (
                  json &&
                  json[res.section] &&
                  json[res.section].data &&
                  json[res.section].data[0] &&
                  json[res.section].data[0][fields] &&
                  json[res.section].data[0][fields] != ""
                ) {
                } else {
                  const checkSectionAvailable = missingFields.findIndex(
                    (x) => x.section == [res.section]
                  );

                  if (checkSectionAvailable == -1) {
                    let data = {
                      section: res.section,
                      score: res.score,
                      fields: [fields],
                    };
                    missingFields.push(data);
                  } else {
                    missingFields[checkSectionAvailable] &&
                      missingFields[checkSectionAvailable].fields &&
                      missingFields[checkSectionAvailable].fields.push(fields);
                  }
                }
              } else {
                const checkSectionAvailable = missingFields.findIndex(
                  (x) => x.section == [res.section]
                );

                if (checkSectionAvailable == -1) {
                  let data = {
                    section: res.section,
                    score: res.score,
                    fields: [fields],
                  };
                  missingFields.push(data);
                } else {
                  missingFields[checkSectionAvailable] &&
                    missingFields[checkSectionAvailable].fields &&
                    missingFields[checkSectionAvailable].fields.push(fields);
                }
              }
            });
          }

          let missingFieldsIndex =
            missingFields &&
            missingFields.findIndex((x) => x.section == res.section);
          if (
            missingFields[missingFieldsIndex] &&
            missingFields[missingFieldsIndex].fields &&
            missingFields[missingFieldsIndex].fields.length > 0
          ) {
            completedPercentage = completedPercentage;
          } else {
            completedPercentage = completedPercentage + res.score;
          }
        } else {
          let data = {
            section: res.section,
            score: res.score,
          };
          missingSections.push(data);
        }
      });
    calculatedData["completedPercentage"] = completedPercentage;
    calculatedData["missingFields"] = missingFields;
    calculatedData["missingSections"] = missingSections;

    //Check the Available Sections

    return calculatedData;
  }
};
